import script from "./FormInputSignature.vue?vue&type=script&setup=true&lang=js"
export * from "./FormInputSignature.vue?vue&type=script&setup=true&lang=js"

import "./FormInputSignature.vue?vue&type=style&index=0&id=cae4c86e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cae4c86e"]])

export default __exports__